import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';

interface FIntroductionCardProps {
  text: string;

  onClick?(): void;
}

function FIntroductionCard({ text, onClick }: FIntroductionCardProps) {
  if (text !== '') {
    return (
      <div className={styles.IntroductionCard_hasDate} onClick={onClick}>
        {text}
      </div>
    );
  }

  return (
    <div className={styles.IntroductionCard} onClick={onClick}>
      <span>
        {FI18n.i18nNext.tAuto('edit_exhibit_description')}
      </span>
    </div>
  );
}

export default FIntroductionCard;
